<template>
    <div class="app-comment" @click.stop="handleFormClick">
        <input class="app-comment__input"
               ref="contentInput"
               placeholder="输入评论..."
               @focus="handleInputFocus"
               v-model="content"
        />
        <!--  -->
        <template v-if="focused">
            <div class="app-row app-comment__input-row">
                <div class="app-col app-col-12">
                    <input class="app-comment__input"
                           placeholder="输入昵称..."
                           v-model="nickName"
                    />
                </div>
                <div class="app-col app-col-12">
                    <input class="app-comment__input"
                           placeholder="输入邮箱..."
                           v-model="email"
                    />
                </div>
            </div>
            <div class="app-comment__action-box">
                <app-button class="app-comment__send-button"
                            :disabled="submitButtonDisabled"
                            @click="handleSendButtonClick"
                >
                    <app-icon class="app-comment__send-icon"
                              value="icon-message"/>
                    发送
                </app-button>
            </div>
        </template>
        <div class="app-comment__loading" v-if="loading">
            <div class="app-comment__loading-mask"/>
            <app-loading/>
        </div>
    </div>
</template>

<script>
    import AppButton from '@components/AppButton'
    import AppIcon from '@components/AppIcon'
    import AppLoading from '@components/AppLoading'
    import createCommentService from '@service/createCommentService'

    export default {
        name: "AppComment",
        props: {
            hostId: {
                type: String
            },
            parentId: {
                type: String
            },
            expand: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                focused: false,
                content: '',
                nickName: '',
                email: '',
                loading: false
            }
        },
        mounted() {
            document.addEventListener('click', this.handleEvent)
            this.init()
        },
        watch: {
            expand: {
                handler(val) {
                    if (val) {

                        this.$nextTick(() => {
                            this.focused = true
                            if (this.$refs.contentInput) {
                                this.$refs.contentInput.focus()
                            }
                        })
                    }
                },
                immediate: true
                // contentInput
            }
        },
        computed: {
            submitButtonDisabled() {
                const {content, nickName, email} = this
                return !this.validate(content, nickName, email)
            }
        },
        methods: {
            init() {
                const {email = '', nickName = ''} = this.getCache()
                this.email = email
                this.nickName = nickName
            },
            handleInputFocus() {
                this.focused = true
            },
            handleEvent() {
                const {focused, expand, content} = this
                if (focused) {
                    if (!content) {
                        if (expand) {
                            this.$emit('blur')
                        } else {
                            this.focused = false
                        }

                    }
                }

            },
            handleFormClick() {
                // nothing
            },
            validate(content, nickName, email) {
                const regEmail = /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
                return (regEmail.test(email) && nickName.trim() && content.trim())
            },
            async createComment() {
                try {
                    this.loading = true
                    const {content, nickName, email, hostId, parentId} = this
                    await createCommentService({
                        content,
                        nickName,
                        email,
                        hostId,
                        parentId
                    })
                    this.content = ''
                    this.$emit('success')
                    this.setCache({
                        nickName,
                        email
                    })
                } catch (e) {
                    console.log(e)
                } finally {
                    this.loading = false
                }
            },
            handleSendButtonClick() {
                const {submitButtonDisabled} = this
                if (!submitButtonDisabled) {
                    this.createComment()
                }
            },
            setCache(data) {
                localStorage.setItem('commentCache', JSON.stringify(data))
            },
            getCache() {
                try {
                    const cache = localStorage.getItem('commentCache')
                    if (cache) {
                        return JSON.parse(cache)
                    } else {
                        return {}
                    }
                } catch (e) {
                    return {}
                }
            }
        },
        beforeDestroy() {
            document.removeEventListener('click', this.handleEvent)
        },
        components: {
            AppIcon,
            AppButton,
            AppLoading
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .app-comment {
        position: relative;
        margin-top: $paddingMD;
        margin-bottom: $paddingMD;
        padding: $paddingMD;
        border-radius: $radius;
        background-color: $componentHighLightColor;
        background-color: var(--componentHighLightColor);
        overflow: hidden;
        @include transition-colors;

        &.focused {

            .app-comment__input {
                border-color: $primaryColor;
            }
        }

        &__input {
            width: 100%;
            font-size: $fontSizeCommon;
            line-height: 1.7;
            padding: $paddingBase $paddingMD;
            font-weight: $fontWeightBolder;
            border-radius: $radius;
            color: $textColor;
            color: var(--textColor);
            background-color: $componentBackgroundColor;
            background-color: var(--componentBackgroundColor);

            outline: none;
            @include transition-colors;

            &::placeholder {
                opacity: .5;
            }
        }

        &__input-row {
            margin-top: $paddingMD;
        }

        .app-col:not(:first-child) {
            padding-left: 0;
            margin-top: $paddingMD;
        }

        &__action-box {
            margin-top: $paddingMD;
            text-align: right;
        }

        &__send-button {
            display: inline-block;
            padding: $paddingBase $paddingMD;
            border-radius: $radius;
            color: #fff;
            background-color: $darkPrimaryColor;
            @include transition-colors;

            &[disabled] {
                opacity: .3;
            }

            .app-icon {
                color: #fff;
            }

            &:hover {
                color: #fff;
                background-color: $primaryColor;

                .app-icon {
                    color: #fff;
                }
            }
        }


        &__loading {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;

            &-mask {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                background-color: $componentBackgroundColor;
                background-color: var(--componentBackgroundColor);
                opacity: .6;
            }

        }
    }

    @media (min-width: 1280px) {
        .app-col:not(:first-child) {
            padding-left: $paddingMD !important;
            margin-top: 0 !important;
        }

    }

</style>